<template>
  <NavbarMobile
    :menuvisibility="menu_visibility"
    :userinfo="menuvisibility"
    :switchmodal="showModalSwitch"
  ></NavbarMobile>
  <NavbarDesktop
    :collapse="collapse"
    :toggle="toggle"
    :menuvisibility="menu_visibility"
    :userinfo="menuvisibility"
    :switchmodal="showModalSwitch"
  ></NavbarDesktop>
</template>

<script>
import NavbarMobile from "./navbar-mobile.vue";
import NavbarDesktop from "./navbar-desktop.vue";
import { mapState } from "vuex";

export default {
  /**
   * Defines the events emitted by this component.
   */
  emits: ["collapse", "showModalSwitch"],

  /**
   * Component props.
   */
  props: {
    menuvisibility: Array,
  },

  /**
   * Child components.
   */
  components: {
    NavbarDesktop,
    NavbarMobile,
  },

  computed: {
    ...mapState({
      currUser: (state) => state.Auth.currUser,
      userInfo: (state) => state.Auth.userInfo,
    }),

    /**
     * Filters the menu navigation items based on the marketing module toggle
     * and specific user module permissions.
     * 
     * @returns {Array} Filtered list of menu objects.
     */
    filteredMenu() {
      const isMarketingEnabled = this.marketingModuleFlag === 'ACTIVE';
      const isTransactionReportEnabled = this.transactionReportModuleFlag === 'ACTIVE';
      const isNewsletterEnabled = this.newsletterModuleFlag === 'ACTIVE';
      const isPromotionsEnabled = this.promotionsModuleFlag === 'ACTIVE';
      const isBranchProductEnabled = this.branchProductManagementFlag === 'ACTIVE';
      const isMerchantProductEnabled = this.merchantProductFlag === 'ACTIVE';
      // const isMerchantAccessTokenEnabled = this.merchantAccessTokenFlag === 'ACTIVE';
      let filtered = this.menu;

      if (!isMarketingEnabled && !this.hasUpsellContent('marketing_module')) {
        filtered = filtered.filter((item) => item.link_name !== "Marketing");
      }

      if (!isTransactionReportEnabled && !this.hasUpsellContent('transaction_report_module')) {
        filtered = filtered.filter((item) => item.link_name !== "Transaction Report");
      }

      if (!isNewsletterEnabled && !this.hasUpsellContent('newsletter_module')) {
        filtered = filtered.filter((item) => item.link_name !== "Newsletter");
      }

      if (!isPromotionsEnabled && !this.hasUpsellContent('promotions_module')) {
        filtered = filtered.filter((item) => item.link_name !== "Promotions");
      }

      if (!isBranchProductEnabled) {
        filtered = filtered.filter((item) => item.link_name !== "Branch Product");
      }

      if (!isMerchantProductEnabled) {
        filtered = filtered.filter((item) => item.link_name !== "Product");
      }

      // if (!isMerchantAccessTokenEnabled) {
      //   filtered = filtered.filter((item) => item.link_name !== "Access Token" && item.link_name !== "Authentication URL");
      // }

      return this.filterMenuByPermissions(filtered);
    },

    pointControlFlag() {
      return this.$store.state.FeatureFlag?.pointControl?.flag || 'DECENTRALIZE';
    },

    marketingModuleFlag() {
      return this.$store.state.FeatureFlag?.marketingModule?.flag || 'ACTIVE';
    },

    transactionReportModuleFlag() {
      return this.$store.state.FeatureFlag?.transactionReportModule?.flag || 'ACTIVE';
    },

    newsletterModuleFlag() {
      return this.$store.getters['FeatureFlag/getNewsletterModuleFlag'];
    },
    benefitModuleFlag() {
      return this.$store.getters['FeatureFlag/getBenefitModuleFlag'];
    },
    promotionsModuleFlag() {
      return this.$store.getters['FeatureFlag/getPromotionsModuleFlag'];
    },
    branchProductManagementFlag() {
      return this.$store.getters['FeatureFlag/getBranchProductManagementFlag'];
    },
    merchantProductFlag() {
      return this.$store.getters['FeatureFlag/getMerchantProductFlag'];
    },
    // merchantAccessTokenFlag() {
    //   return this.$store.getters['FeatureFlag/getMerchantAccessTokenFlag'];
    // },
    voucherGiftFlag() {
      return this.$store.getters['FeatureFlag/getVoucherGiftFlag'];
    },
  },

  /**
   * Component data state.
   */
  data: function () {
    return {
      menu: [
        {
          link_name: "Dashboard",
          link_spesific: "/dashboard",
          module_name: null,
        },
        {
          link_name: "Corporate",
          link_spesific: "/corporate",
          module_name: null
        },
        {
          link_name: "Feature Flags",
          link_spesific: "/feature-flags",
          module_name: null
        },
        {
          link_name: "System Log",
          link_spesific: "/systemlog",
          module_name: null,
        },
        {
          link_name: "API Log",
          link_spesific: "/logsapi",
          module_name: null,
        },
        {
          link_name: "Branch",
          link_spesific: "/branch",
          module_name: "branch",
        },
        {
          link_name: "Business Profile",
          link_spesific: "/business-profile",
          module_name: null,
        },
        {
          link_name: "User",
          link_spesific: "/user",
          module_name: "user",
        },
        {
          link_name: "Levels",
          link_spesific: "/level",
          module_name: null,
        },
        {
          link_name: "Member",
          link_spesific: "/member",
          module_name: "member",
        },
        {
          link_name: "Member Tier",
          link_spesific: "/membertier",
          module_name: "member-tier",
        },
        {
          link_name: "User Roles",
          link_spesific: "/roles",
          module_name: "user-roles",
        },
        {
          link_name: "Themes",
          link_spesific: "/themes",
          module_name: null
        },
        {
          link_name: "Point Management",
          is_dropdown: true,
          children: [
            {
              link_name: "Configuration",
              link_spesific: "/point-settings",
              module_name: null,
              icon: "fas fa-cog",
            },
            {
              link_name: "Manipulation",
              link_spesific: "/inject/point",
              module_name: "point-manipulation",
              icon: "far fa-money-bill-alt",
            },
            {
              link_name: "Point Plan",
              link_spesific: "/point/plan",
              module_name: "point_plan",
              icon: "far fa-calendar-check",
            },
            {
              link_name: "Expiration",
              link_spesific: "/point-expiration",
              module_name: "point_plan",
              icon: "fas fa-hourglass-end",
            },
          ]
        },
        {
          link_name: "Transaction Report",
          link_spesific: "/transaction-report",
          module_name: "transaction-report",
        },
        {
          link_name: "Merchant",
          link_spesific: "/merchant",
          module_name: "merchant",
        },
        {
          link_name: "Product",
          link_spesific: "/product",
          module_name: "product",
        },
        {
          link_name: "Branch Product", 
          link_spesific: "/branch/product",
          module_name: "product", 
        },

        {
          link_name: "Marketing",
          link_spesific: "/marketings",
          module_name: "marketing",
        },
        {
          link_name: "Transaction",
          link_spesific: "/transaction",
          module_name: "transaction",
        },

        {
          link_name: "Connection Apps",
          link_spesific: "/connection-apps",
        },
        {
          link_name: "Promotions",
          link_spesific: "/promotions",
          module_name: "promotions",
        },
        {
          link_name: "Newsletter",
          link_spesific: "/newsletter",
          module_name: "newsletter",
        },
        {
          link_name: "Benefit",
          link_spesific: "/benefit",
          module_name: "benefit",
        },
        {
          link_name: "Tax Service",
          link_spesific: "/tax-service",
          module_name: "tax-service",
        },
        {
          link_name: "Policies",
          link_spesific: "/policies",
          module_name: "policies",
        },
        {
          link_name: "Voucher",
          link_spesific: "/voucher",
          module_name: "voucher",
        },
        {
          link_name: "Voucher Redeem",
          link_spesific: "/voucher/redeem",
          module_name: "voucher_redeem",
        },
        {
          link_name: "Voucher Gift",
          link_spesific: "/voucher/gift",
          module_name: "voucher",
        },
        {
          link_name: "Voucher Gift History",
          link_spesific: "/voucher/gift/history",
          module_name: "voucher",
        },
        {
          link_name: "Member Dashboard",
          link_spesific: "/client/dashboard",
          module_name: null,
        },
        {
          link_name: "My Transactions",
          link_spesific: "/client/transaction-history",
          module_name: null,
        },
        {
          link_name: "My Vouchers",
          link_spesific: "/client/voucher",
          module_name: null,
        },
        {
          link_name: "Deals",
          link_spesific: "/client/deals",
          module_name: null,
        },
        {
          link_name: "Member Qr Code",
          link_spesific: "/client/qrcode",
          module_name: null,
        },
        // {
        //   link_name: "Access Token",
        //   link_spesific: "/user/access-token",
        //   module_name: "access-token",
        // },
        // {
        //   link_name: "Authentication URL",
        //   link_spesific: "/user/authentication-url",
        //   module_name: null,
        // },
      ],
      collapse: false,
      menu_visibility: [],
    };
  },

  /**
   * Initializes the menu visibility when the component is mounted.
   */
  mounted: function () {
    if (this.menuvisibility) {
      this.menu_visibility = this.filteredMenu.filter((v) =>
        this.menuvisibility.includes(v.link_name)
      );
    }
  },

  watch: {
    /**
     * Updates menu visibility when the prop changes.
     * 
     * @param {Array} newVal - New visibility settings.
     */
    menuvisibility(newVal) {
      this.menu_visibility = this.filteredMenu.filter((v) =>
        newVal.includes(v.link_name)
      );
    },

    /**
     * Watches for changes in user modules to re-evaluate permissions correctly.
     */
    "userInfo.modules": {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    pointControlFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    marketingModuleFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    transactionReportModuleFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    newsletterModuleFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    benefitModuleFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    promotionsModuleFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    branchProductManagementFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    merchantProductFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    merchantAccessTokenFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    },
    voucherGiftFlag: {
      handler() {
        if (this.menuvisibility) {
          this.menu_visibility = this.filteredMenu.filter((v) =>
            this.menuvisibility.includes(v.link_name)
          );
        }
      },
      deep: true,
    }
  },

  methods: {
    /**
     * Filters navigation items based on user role and module permissions.
     * Root users see everything. Other users see items matching their module read/write access.
     * 
     * @param {Array} menuItems - Original menu items to filter.
     * @returns {Array} Permission-filtered menu items.
     */
    filterMenuByPermissions(menuItems) {
      const isRoot = this.currUser?.level === 'root';
      const pointFlag = this.$store.state.FeatureFlag?.pointControl?.flag?.toUpperCase() || 'DECENTRALIZE';
      const businessProfile = this.$store.state.Auth?.selectedBusinessProfile || {};
      const isMerchant = !!businessProfile.merchant_id || this.currUser?.level === 'merchant';
      
      // Deep clone menuItems to avoid Vue data mutation issues on reactive properties
      let filteredItems = JSON.parse(JSON.stringify(menuItems));

      let filtered = filteredItems.filter(item => {
        // Handle Point Management Parent and Children based on flag and context
        if (item.link_name === 'Point Management') {
          if (pointFlag === 'NONACTIVE') {
            if (isMerchant || isRoot || !this.hasUpsellContent('point_control')) {
              return false;
            }
            item.children = item.children.filter(child => {
              return child.link_name === 'Configuration' || child.link_name === 'Manipulation' || child.link_name === 'Expiration' || child.link_name === 'Point Plan';
            });
            return item.children.length > 0;
          }

          // Centralize & Decentralize: split children by context, but Manipulation is always visible
          item.children = item.children.filter(child => {
            if (child.link_name === 'Manipulation') {
              return true;
            }

            if (isMerchant) {
              return child.link_name === 'Point Plan' && pointFlag === 'DECENTRALIZE';
            } else {
              if (child.link_name === 'Point Plan') return pointFlag === 'CENTRALIZE';
              return child.link_name === 'Configuration' || child.link_name === 'Expiration';
            }
          });

          return item.children.length > 0;
        }

        // Hide all voucher menus when point control is NONACTIVE
        if (pointFlag === 'NONACTIVE') {
          const voucherMenus = ['Voucher', 'Voucher Redeem', 'Voucher Gift', 'Voucher Gift History'];
          if (voucherMenus.includes(item.link_name)) {
            if (isRoot || !this.hasUpsellContent('point_control')) return false;
          }
        }

        // Handle marketing module feature flag
        if (item.link_name === 'Marketing' && this.marketingModuleFlag === 'NONACTIVE') {
          if (isRoot || !this.hasUpsellContent('marketing_module')) return false;
        }

        // Handle transaction report module feature flag
        if (item.link_name === 'Transaction Report' && this.transactionReportModuleFlag === 'NONACTIVE') {
          if (isRoot || !this.hasUpsellContent('transaction_report_module')) return false;
        }

        // Handle newsletter module feature flag
        if (item.link_name === 'Newsletter' && this.newsletterModuleFlag === 'NONACTIVE') {
          if (isRoot || !this.hasUpsellContent('newsletter_module')) return false;
        }

        // Handle benefit module feature flag
        if (item.link_name === 'Benefit' && this.benefitModuleFlag === 'NONACTIVE') {
          if (isRoot) return false;
        }

        // Handle promotions module feature flag
        if (item.link_name === 'Promotions' && this.promotionsModuleFlag === 'NONACTIVE') {
          if (isRoot || !this.hasUpsellContent('promotions_module')) return false;
        }

        // Handle branch product management feature flag
        if (item.link_name === 'Branch Product' && this.branchProductManagementFlag === 'NONACTIVE') {
          if (isRoot) return false;
        }

        // Handle merchant product feature flag
        if (item.link_name === 'Product' && this.merchantProductFlag === 'NONACTIVE') {
          if (isRoot) return false;
        }

        // Handle merchant access token feature flag
        // if ((item.link_name === 'Access Token' || item.link_name === 'Authentication URL') && this.merchantAccessTokenFlag === 'NONACTIVE') {
        //   if (isRoot) return false;
        // }

        // Handle voucher gift feature flag
        if ((item.link_name === 'Voucher Gift' || item.link_name === 'Voucher Gift History') && this.voucherGiftFlag === 'NONACTIVE') {
          if (isRoot || !this.hasUpsellContent('voucher_gift')) return false;
        }

        return true;
      });
      
      if (isRoot) {
        return filtered;
      }

      const userModules = this.userInfo?.modules || [];

      return filtered.filter(item => {
        // If it's a dropdown, correctly filter its children based on permissions
        if (item.children) {
          item.children = item.children.filter(child => {
            if (!child.module_name) return true;
            const module = userModules.find((mod) => mod.module_name === child.module_name);
            return module && (module.read === 1 || module.write === 1);
          });
          return item.children.length > 0;
        }

        if (!item.module_name) {
          return true;
        }

        const module = userModules.find((mod) => mod.module_name === item.module_name);

        if (!module) {
          return false;
        }

        return module.read === 1 || module.write === 1;
      });
    },

    /**
     * Helper to check if an upsell content is active for a feature
     */
    hasUpsellContent(featureKey) {
      const content = this.$store.state['feature-upsell']?.contents?.[featureKey];
      return !!content && content.is_active !== false;
    },

    /**
     * Toggles the sidebar collapse state and emits the event.
     */
    toggle() {
      this.collapse = !this.collapse;
      this.$emit("collapse");
    },

    /**
     * Emits the event to show the business profile switch modal.
     */
    showModalSwitch() {
      this.$emit("showModalSwitch");
    },
  },
};
</script>


